<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('settings.settingsLabel') }}</span>
        <h3 class="page-title">{{ $t('settings.userGroups.addNewUserGroup') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/ustawienia/grupy-uzytkownikow')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('ui.backToList') }}
        </d-button>
        <d-button theme="success" @click.prevent="validateForm">
          <i class="material-icons">add</i>
          {{ $t('settings.userGroups.addNewUserGroup') }}
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs v-sticky-tabs card>
          <!-- Dane ogólne -->
          <d-tab
            :title="$t('ui.generalInfo')"
            active>
            <h4 class="mb-3 pb-3 border-bottom">
              {{ $t('ui.generalInfo') }}
            </h4>

            <validation-observer ref="user-group-new-form" tag="form">
              <div class="form-group">
                <label for="name">
                  {{ $t('settings.userGroups.groupName') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </validation-observer>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'user-group-new',
  data() {
    return {
      name: ''
    };
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['user-group-new-form'], this.submitForm);
    },
    submitForm () {
      FormUtils.submit({
        $http: this.$http,
        endpoint: '/users/groups/store',
        formData: {
          name: this.name
        },
        successTitle: this.$t('settings.userGroups.addUserGroupSuccessTitle'),
        successText: this.$t('settings.userGroups.addUserGroupSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.userGroups.addUserGroupErrorText'),
        successAction: () => {
          this.$router.push('/ustawienia/grupy-uzytkownikow')
        }
      });
    }
  }
};
</script>
